import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  // null = checking, false = not authenticated, object = authenticated user
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Returning from Google OAuth: let AuthCallback exchange the session first.
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    let active = true;
    api
      .me()
      .then((d) => active && setUser(d.user))
      .catch(() => {
        if (active) setUser(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const logout = useCallback(async () => {
    try { await api.logout(); } catch (e) { console.debug("logout API call failed (ignored):", e); }
    // Drop any cached API responses so the next account never sees stale data.
    try { navigator.serviceWorker?.controller?.postMessage("clear-api-cache"); } catch (e) { console.debug("cache-clear message failed (ignored):", e); }
    setUser(false);
    window.location.href = "/login";
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
